import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OfferLink } from './OfferLink';
import { product } from '../data/salesCopy';
export function Hero() {
  return <section className="bg-brand-sage px-4 pb-8 pt-7 text-brand-ivory sm:pb-10 sm:pt-9" data-id="element-121" data-mp="9k0ep7vr8fpn">
      <div className="mx-auto max-w-3xl text-center" data-id="element-122" data-mp="4m8msdv40tlg">
        <p className="mb-3 inline-flex items-center gap-1.5 rounded-full border border-brand-gold/60 bg-brand-gold/15 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.15em] text-brand-gold sm:text-xs" data-id="element-123" data-mp="4njnu5x67n8v">
          <StarIcon className="h-3 w-3 fill-brand-gold" aria-hidden="true" data-id="element-124" data-mp="x8jndoipuui9" />
          Complete 6-in-1 System
        </p>

        <h1 className="font-serif text-[26px] font-extrabold uppercase leading-[1.1] text-white sm:text-4xl" data-id="element-125" data-mp="ncgk2fc4optq">
          The Complete Ready-to-Teach System for{' '}
          <span className="text-brand-sand" data-id="element-126" data-mp="3czfkty10i55i">Yin Yoga Instructors</span>
        </h1>

        <p className="mx-auto mt-3 max-w-2xl text-[13px] font-medium leading-snug text-brand-ivory/85 sm:text-[15px]" data-id="element-127" data-mp="380w020y5mzeq">
          Stop spending hours building sequences, choosing poses, planning
          transitions, preparing modifications and wondering what you're going to
          teach in your next class.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-[13px] font-medium leading-snug text-brand-ivory/85 sm:text-[15px]" data-id="element-128" data-mp="39cpcgsselh1u">
          Get one complete professional system filled with ready-to-teach Yin
          Yoga classes, pose variations, targeted sequences, teaching scripts,
          class-building tools and instructor resources — organized and ready
          when you need them.
        </p>

        <OfferLink className="mt-4 block" data-id="element-129" data-mp="2qhqx3qw3b823">
          <img src={product.image} alt="YIN YOGA READY™ — the complete 6-in-1 ready-to-teach system box set" className="mx-auto w-full max-w-[280px] drop-shadow-2xl transition-transform duration-200 ease-smooth hover:scale-[1.02] sm:max-w-[360px]" data-id="element-130" data-mp="2vi5558xoyi04" />
        </OfferLink>

        <div className="mx-auto mt-4 max-w-md" data-id="element-131" data-mp="s2tenov66frb">
          <CTAButton subLabel={`🛡️ ${product.guarantee}`} data-id="element-132" data-mp="nbbdazp8id5t">
            🧘 YES! I WANT THE COMPLETE SYSTEM
          </CTAButton>
        </div>
      </div>
    </section>;
}